import { omit } from 'lodash-es';

import { toServerDateTimeOptional } from '../../common/utils/dateUtils';
import {
  NewShipmentDateSpecialValue,
  applyNewShipmentDateSpecialValue,
} from './newShipmentConversions';
import { getValidPackages } from '../../forms/shipments/shipmentCommon';

export function formLocationToGraphqlInput(location) {
  return {
    companyName: location?.companyName,
    address: {
      addressLine1: location?.address?.addressLines?.[0],
      addressLine2: location?.address?.addressLines?.[1],
      addressLine3: location?.address?.addressLines?.[2],
      city: location?.address?.city,
      stateProvince: location?.address?.stateProvince,
      postalCode: location?.address?.postalCode,
      country:
        location?.address?.country?.text ||
        location?.address?.country?.code ||
        location?.address?.country,
    },
    contact: location?.contact,
  };
}

export function formToGraphqlQuoteInput(form) {
  const {
    account,
    serviceType,
    origin,
    destination,
    packages,
    pickupDateTime,
    commodity,
    dangerousGoods,
    exceptedQuantity,
    unNumber = [],
    unitSystem,
  } = form || {};
  return {
    account: account?.number,
    serviceType: serviceType?.code,
    pickupDateTime: {
      scheduled: toServerDateTimeOptional(pickupDateTime),
      ...applyNewShipmentDateSpecialValue(
        form?.['pickupDateTime-specialValue'],
        toServerDateTimeOptional(form?.['pickupDateTime-specialValueData'])
      ),
      isNow:
        form?.['pickupDateTime-specialValue'] ===
        NewShipmentDateSpecialValue.NOW,
    },
    shipper: formLocationToGraphqlInput(origin),
    consignee: formLocationToGraphqlInput(destination),
    unitSystem,
    packageInfo: getValidPackages(packages)?.map(
      (
        { actualWeight, length, height, width, packageSource, packagingType },
        index
      ) => ({
        commodity,
        dangerousGoods,
        // Only the first package should include unNumbers.
        // If we include it in every package, the backend will duplicate the unNumber in the response.
        // This needs to be addressed later, as unNumber is sent inside the package but received outside.
        unNumber:
          index === 0 ? unNumber.map(number => ({ code: number?.code })) : [],
        exceptedQty: exceptedQuantity,
        packageSource: omit(packageSource, '__typename'),
        packagingType: omit(packagingType, '__typename'),
        packageOptions: {
          pieces: 1,
          dimensionalPackage: {
            case: index,
            actualWeight,
            length,
            height,
            width,
          },
        },
      })
    ),
  };
}
